const source = process.env.REACT_APP_FILE_STORAGE || process.env.REACT_APP_BACKEND_URL;
const prefixSource = process.env.REACT_APP_PREFIX_FILE_STORAGE || 'ms-auth/api/files/download';

const sourcePath = `${source}/${prefixSource}`;

export const getFromSource = image => {
  if (!image) return '';
  const isLocalImage = image.startsWith('/images') || image.startsWith('images/') || image.startsWith('data:');
  const isSocialOrCDNAvatar =
    (image && image.startsWith('http')) || (image && image.startsWith('https'));
  image = image.replace('/uploads', '');
  return isSocialOrCDNAvatar || isLocalImage ? image : `${sourcePath}/${image}`;
};
